// The wallet quote describes the real grant; VIP daily_bonus is legacy display metadata.
export function dailyRewardLabel(bonus) {
  if (!bonus || bonus.amount == null) return "Daily reward";
  const coins = `${Number(bonus.amount).toLocaleString()} PCoins`;
  return bonus.cash_eligible && Number(bonus.cash_amount) > 0
    ? `${coins} + ${Number(bonus.cash_amount).toFixed(2)} PCash`
    : coins;
}

export function dailyRewardTerms(bonus) {
  if (!bonus || !(Number(bonus.cash_amount) > 0)) return "";
  const cap = Number(bonus.cash_cap).toFixed(2);
  return bonus.cash_eligible
    ? `PCash requires 1× playthrough. Available with a cash balance of $${cap} or less.`
    : `PCash unavailable while your cash balance is above $${cap}. PCash requires 1× playthrough.`;
}

export function dailyRewardClaimMessage(grant) {
  const coins = `${Number(grant.amount).toLocaleString()} PCoins`;
  return Number(grant.cash_bonus) > 0
    ? `Claimed ${coins} + ${Number(grant.cash_bonus).toFixed(2)} PCash! PCash requires 1× playthrough.`
    : `Claimed ${coins}!`;
}
